import { Card } from "@/components/Card/card";
import AppliedFilterChip from "@/components/Filter/AppliedFilterChip";
import AvailableFilterChip from "@/components/Filter/AvailableFilterChip";
import { HStack } from "@/components/Layout";
import type { ImportCsvError, MutateTableRows } from "../../types";

type Props = {
  mutateTableRows: MutateTableRows;
  error: ImportCsvError;
  filterError: boolean;
};

const SearchFilterBar = ({ mutateTableRows, error, filterError }: Props) => {
  const handleOnClickFilterError = (filterError: boolean) => {
    mutateTableRows({
      dryrun: true,
      filterError,
    });
  };
  if (!error.rowsCount) return null;

  return (
    <Card className="w-full">
      <HStack className="p-3">
        <div className="flex items-center gap-3">
          {filterError && (
            <AppliedFilterChip
              iconName="TriangleAlertIcon"
              className=""
              onClear={() => handleOnClickFilterError(false)}
            >
              Error
            </AppliedFilterChip>
          )}

          {!filterError && (
            <AvailableFilterChip
              iconName="TriangleAlertIcon"
              onClick={() => handleOnClickFilterError(true)}
            >
              Error
            </AvailableFilterChip>
          )}
        </div>
      </HStack>
    </Card>
  );
};

export default SearchFilterBar;
